import React, { useState, useEffect, useRef } from 'react';
import HeaderSearchBar from "../../../Components/UiComponents/HeaderSearch";
import _ from 'lodash';
import { Dialog } from "primereact/dialog";
//components
import DataTable from '../../../Components/UiComponents/DataTable';
import ButtonElement from '../../../Components/UiComponents/ButtonElement';
import CreateNewAddress from './CreateNewAddress';
import EditAddress from './EditAddress';
import Loader from "../../../Components/UiComponents/Loader";
import ToastElement from "../../../Components/UiComponents/ToastElement";
import MultiSelectElement from "../../../Components/UiComponents/MultiSelectElement";
//services
import { filter, addressMultiDelete } from '../../../Services/addressService';
import { all } from "../../../Services/clientService";
import { allOrg } from "../../../Services/organisationService";
import { getField } from '../../../Services/tooltipService';
import { useNavigate } from 'react-router-dom';

const Address = (props) => {
    const [loading, setLoading] = useState(false)
    const [filterAddressDetails, setFilterAddressDetails] = useState([]);
    const [addressData, setAddressData] = useState([])
    const [position, setPosition] = useState("center");
    const [visible, setVisible] = useState(false);
    const [fieldDetails, setFieldDetails] = useState([]);
    const [addressSections, setAddressSections] = useState([]);
    const [commonFields, setCommonFields] = useState([]);
    const [branchIdFromLS, setBranchIdFromLS] = useState();
    const [totalRecords, setTotalRecords] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);
    const [searchedContactLength, setSearchedContactLength] = useState(0);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: -1,
        sortField: "updated_date",
        sortOrder: -1,
        pattern: "All"
    });
    const [filterAssociated, setFilterAssociated] = useState([]);
    const [filterAssociatedLabel, setFilterAssociatedLabel] = useState([]);
    const [filterAssociatedId, setFilterAssociatedId] = useState([]);
    const [idsAddress, setIdsAddress] = useState([]);
    const [deleted, setDeleted] = useState(false)
    const [clients, setClients] = useState([]);
    const [organisations, setOrganisations] = useState([]);
    const [filterClient, setFilterClient] = useState([]);
    const [filterOrg, setFilterOrg] = useState([]);
    const [deleteContactDialog, setDeleteContactDialog] = useState(false);
    const [updatedAddress, setUpdatedAddress] = useState([]);
    const [addressDetails, setAddressDetails] = useState([]);
    const [visibleEdit, setVisibleEdit] = useState(false);

    const navigate = useNavigate()
    const dropdownRef = useRef(null);
    const toastRef = useRef();

    const associated = [
        // { label: 'All', value: 'All' },
        { label: "Client", value: "Client" },
        // { label: "Organisation", value: "Organisation" },
    ];

    useEffect(() => {
        const enduserStr = localStorage.getItem("enduser");
        if (enduserStr) {
            const enduser = JSON.parse(enduserStr);
            const branch = enduser.branch;
            setBranchIdFromLS(branch);
        } else {
            navigate("/login")
            localStorage.clear()
        }
    }, []);

    useEffect(() => {
        getCustomerField();
        getAddressDetails();
        getAllClients();
        getAllOrganisations();
    }, [props?.customerId]);

    useEffect(() => {
        getAddressDetails();
    }, [lazyParams]);

    useEffect(() => {
        getAddressDetails();
    }, [filterAssociatedLabel,
        filterAssociatedId,
    ]);

    useEffect(() => {
        if (!filterAssociated.includes("Client")) {
            setFilterClient([]);
        }
        if (!filterAssociated.includes("Organisation")) {
            setFilterOrg([]);
        }
    }, [filterAssociated])

    const getAddressDetails = async function () {
        try {
            if (props.customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            setLoading(true)
            const { first, rows, sortField, sortOrder, pattern } = lazyParams;
            let data = {
                skip: first,
                limit: rows,
                pattern: pattern,
                sortBy: sortField,
                orderBy: sortOrder,
                filter: {
                    associated:
                        filterAssociatedLabel.length !== 0 ? filterAssociatedLabel : [],
                    associated_id:
                        filterAssociatedLabel.length !== 0
                            ? filterAssociatedId.length !== 0
                                ? filterAssociatedId
                                : []
                            : [],
                },
            };
            const addressData = await filter(data.skip, data.limit, props?.customerId, data.pattern, searchQuery, data.sortBy, data.orderBy, data.filter);
            setAddressData(addressData.data.addr)
            setTotalRecords(addressData?.data?.count);
            setLoading(false)
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false)
        }
    };

    const getCustomerField = async function () {
        try {
            if (props.customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            setLoading(true);
            if (props?.customerId !== null) {
                const customerDAta = await getField(props?.customerId);
                setFieldDetails(customerDAta.data.cust[0].modules);
                setCommonFields(
                    _.find(customerDAta?.data.cust[0].modules, {
                        module_name: "Common Fields",
                    }).sub_modules[0].fields
                );
                setAddressSections(
                    _.find(
                        _.find(customerDAta?.data.cust[0].modules, {
                            module_name: "Address Book",
                        }).sub_modules,
                        { ESG_sub_module_name: "Address" }
                    )?.sections
                );
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false)
        }
    };

    const getAllClients = async () => {
        try {
            const enduserStr = localStorage.getItem("enduser");
            if (props.customerId === null && enduserStr === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            const enduser = JSON.parse(enduserStr);
            if (enduser) {
                const clientres = await all(
                    props?.customerId,
                    enduser?.branch,
                    "client_name",
                    1,
                    {},
                    "Other"
                );
                const clients = clientres?.data?.client?.map((cli) => ({
                    ...cli,
                    label: cli.client_name,
                }));

                setClients(clients);
            } else {
                navigate("/login")
                localStorage.clear()
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    const getAllOrganisations = async () => {
        try {
            const enduserStr = localStorage.getItem("enduser");
            if (props.customerId === null && enduserStr === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            const enduser = JSON.parse(enduserStr);
            if (enduser) {
                const orgres = await allOrg(props?.customerId, enduser?.branch);
                const organisations = orgres?.data?.organisation.map((org) => ({
                    ...org,
                    label: org.organisation_name,
                }));
                setOrganisations(organisations);
            } else {
                navigate("/login")
                localStorage.clear()
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    };

    const checkingDisplayName = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.address_name != null && rowData.address_name !== "") {
            return <div className="form-label-text text-left mr-20 pointer mar-l-5">{rowData.address_name}</div>;
        }
    };

    const checkingAddressName = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.building_name != null && rowData.building_name !== "") {
            return <div>{rowData.building_name}</div>;
        }
    };

    const checkingAddressName1 = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.address_line_two != null && rowData.address_line_two !== "") {
            return <div>{rowData.address_line_two}</div>;
        }
    };

    const checkingOfficeNumber = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.office_addr_contact != null && rowData.office_addr_contact !== "") {
            return <div>{rowData.office_addr_contact}</div>;
        }
    };

    const checkingTelephone = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.telephone_number != null && rowData.telephone_number !== "") {
            return <div>{rowData.telephone_number}</div>;
        }
    };

    const checkingCityName = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.city != null && rowData.city !== "") {
            return <div>{rowData.city}</div>;
        }
    };

    const checkingStateName = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.state != null && rowData.state !== "") {
            return <div>{rowData.state}</div>;
        }
    };

    const checkingCountryName = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.country != null && rowData.country !== "") {
            return <div>{rowData.country}</div>;
        }
    };

    const checkingpostcode = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.postcode != null && rowData.postcode !== "") {
            return <div>{rowData.postcode}</div>;
        }
    };

    const checkingAssociatedTo = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.associated != null && rowData.associated !== "") {
            return <div>{rowData.associated}</div>;
        }
    };

    const checkingAssociatedName = (rowData) => {
        // Check if display name exists and is not empty
        if (rowData.associated_name != null && rowData.associated_name !== "") {
            return <div>{rowData.associated_name}</div>;
        }
    };

    const locationTemplate = () => {
        return _.find(props.addressBookData.commonFields, { field_name: "Location Name" })?.display_name
    }

    const addressTemplate1 = () => {
        return _.find(props.addressBookData.commonFields, { field_name: "Address Line 1" })?.display_name
    }

    const addressTemplate2 = () => {
        return _.find(props.addressBookData.commonFields, { field_name: "Address Line 2" })?.display_name
    }

    const officeTemplate = () => {
        return _.find(props.addressBookData.commonFields, { field_name: "Office Number" })?.display_name
    }

    const phoneTemplate = () => {
        return _.find(props.addressBookData.commonFields, { field_name: "Telephone Number" })?.display_name
    }

    const cityTemplate = () => {
        return _.find(props.addressBookData.commonFields, { field_name: "City" })?.display_name
    }

    const stateTemplate = () => {
        return _.find(props.addressBookData.commonFields, { field_name: "State/County" })?.display_name
    }

    const codeTemplate = () => {
        return _.find(props.addressBookData.commonFields, { field_name: "Postcode" })?.display_name
    }

    const countryTemplate = () => {
        return _.find(props.addressBookData.commonFields, { field_name: "Country" })?.display_name
    }

    const associatedTemplate = () => {
        return _.find(props.addressBookData.commonFields, { field_name: "Associated to" })?.display_name
    }

    const associatedNameTemplate = () => {
        return _.find(props.addressBookData.commonFields, { field_name: "Associated Name" })?.display_name
    }

    const columns = [
        // Column configuration for the "Question" field
        {
            field: "address_name",
            header: locationTemplate,
            body: checkingDisplayName,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            sortable: true
        },
        {
            field: "building_name",
            header: addressTemplate1,
            body: checkingAddressName,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            sortable: true
        },
        {
            field: "address_line_two",
            header: addressTemplate2,
            body: checkingAddressName1,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            sortable: true
        },
        {
            field: "associated",
            header: associatedTemplate,
            body: checkingAssociatedTo,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            sortable: true
        },
        {
            field: "associated_name",
            header: associatedNameTemplate,
            body: checkingAssociatedName,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            sortable: true
        },
        // {
        //     field: "Office Number",
        //     header: officeTemplate,
        //     body: checkingOfficeNumber,
        //     headerClassName: "header-datatable white-space",
        //     className: 'row-datatable'
        // },
        // {
        //     field: "Telephone Number",
        //     header: phoneTemplate,
        //     body: checkingTelephone,
        //     headerClassName: "header-datatable white-space",
        //     className: 'row-datatable'
        // },
        {
            field: "city",
            header: cityTemplate,
            body: checkingCityName,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            sortable: true
        },
        {
            field: "state",
            header: stateTemplate,
            body: checkingStateName,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            sortable: true
        },
        {
            field: "postcode",
            header: codeTemplate,
            body: checkingpostcode,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            sortable: true
        },
        {
            field: "country",
            header: countryTemplate,
            body: checkingCountryName,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            sortable: true
        }
    ]

    const showEdit = (position) => {
        setPosition(position);
        setVisibleEdit(true);

    };

    const rowClick = async (data) => {
        setAddressDetails(data)
        showEdit();

    };

    const filteredQuestionsArray = (query) => {
        // Convert the query to lowercase for case-insensitive comparison
        const lowerCaseQuery = query.toLowerCase();

        if (lowerCaseQuery.length === 0) {
            // If the query is empty, retrieve the full customer field data
            getAddressDetails();
            setSearchedContactLength(lowerCaseQuery.length); // Update the searched length after resetting the data
        } else {
            if (lowerCaseQuery.length > searchedContactLength) {
                setSearchedContactLength(lowerCaseQuery.length);
            } else {
                setSearchedContactLength(lowerCaseQuery.length);
            }
            // Filter the customer reference data if the query is not empty
            const filteredData = filterAddressDetails.filter((item) => {
                // Check if any value in the item includes the query string
                return Object.values(item).some((value) => {
                    // Convert value to string and to lowercase for comparison
                    return value.toString().toLowerCase().includes(lowerCaseQuery);
                });
            });
            // Update the state with the filtered data
            //   setContactDetails(filteredData);
        }
    };

    const removeField = async (selectedIndex, data) => {
        const ids = [];
        data.forEach((item) => {
            ids.push(item._id);
        });
        setIdsAddress(ids);
        setUpdatedAddress(data);
    };

    const deleteAddress = async () => {
        try {
            setLoading(true);
            await addressMultiDelete(idsAddress).then(response => {
                var namesList = updatedAddress.map((item) => item.address_name).join(", ");
                setUpdatedAddress([]);
                if (response && response?.status === 200) {
                    getAddressDetails();
                    setUpdatedAddress([]);
                    setDeleted(true)
                    toastRef.current.showToast({
                        type: "success",
                        message: response.data.message
                    });
                } else {
                    toastRef.current.showToast({
                        type: "error",
                        message: `Error: failed to delete`,
                    });
                }
                hideDeleteContactDialog();
                getAddressDetails();
            })
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false)
        }
    };

    const show = (position) => {
        setPosition(position);
        setVisible(true);
    };

    const handleHide = () => {
        setVisible(false);
        getAddressDetails();
        setVisibleEdit(false);
    };

    const onPage = (event) => {
        setLazyParams({
            ...lazyParams,
            first: event.first,
            rows: event.rows,
            page: event.page,
        });
    };

    const handleSearchChange = (e) => {
        setSearchQuery(e);
        setLazyParams({
            ...lazyParams,
            first: 0, // Reset to first page on new search
            page: 0,
        });
        // filteredQuestionsArray(e.target.value);
    };

    const handleClearFilter = () => {
        setSearchQuery("");
        setLazyParams({
            ...lazyParams,
            first: 0, // Reset to first page on new search
            page: 0,
        });
        // filteredQuestionsArray("");
    };

    const resetFilter = () => {
        setSearchQuery("");
        setShowDropdown(false);
        setFilterAssociated([]);
        setFilterAssociatedLabel([]);
        setFilterAssociatedId([]);
    };

    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    const handleAssociatedSelection = (event) => {
        setFilterAssociated(event);
        setFilterAssociatedLabel(event);
        if (event.length === 0) {
            setFilterAssociatedId([]);
        }
    };

    const handleClientSelection = (event) => {
        setFilterClient(event);
        // Extract the _id values from the selected branches
        const ids = event.map((item) => item?._id);
        setFilterAssociatedId(ids);
    };

    const handleOrgSelection = (event) => {
        setFilterOrg(event);
        const ids = event.map((item) => item?._id);
        setFilterAssociatedId(ids);
    };

    const confirmDeleteContact = () => {
        setDeleteContactDialog(true);
    };

    const hideDeleteContactDialog = () => {
        setDeleteContactDialog(false);
        getAddressDetails();
    };

    const deleteContactDialogFooter = () => {
        return (
            <div className="cancel-footer">
                <div className="align-center justify-end pb-0">
                    <ButtonElement
                        label="No"
                        className="cancel-new-button"
                        onClick={hideDeleteContactDialog}
                    />
                    <ButtonElement
                        type="submit"
                        label="Yes"
                        className="save-button"
                        onClick={deleteAddress}
                    />
                </div>
            </div>
        );
    };

    const onSort = (e) => {
        let newSortField = e.sortField;
        let newSortOrder = e.sortOrder;
        // Check if the same column is clicked
        if (lazyParams.sortField === newSortField) {
            // If currently sorted ascending, switch to descending
            if (lazyParams.sortOrder === 1) {
                newSortOrder = -1; // Set to descending
            }
            // If currently sorted descending, remove sorting
            else if (lazyParams.sortOrder === -1) {
                newSortField = 'updated_date'; // Remove sorting
                newSortOrder = -1; // Remove sorting
            }
        }
        setLazyParams((prevParams) => ({
            ...prevParams,
            sortField: newSortField,
            sortOrder: newSortOrder,
        }));
    };

    const handleOutsideClick = (event) => {
        if (showDropdown) {
            const target = event.target;
            const dropdownButton = document.querySelector('.clear-filter-button');
            const dropdownContent = document.querySelector('.s-field');
            const multiSelectInput = document.querySelector('.p-multiselect-filter');
    
            if (
                !dropdownContent.contains(target) && 
                target !== dropdownButton && 
                target !== multiSelectInput &&
                !target.closest('.p-multiselect-item') 
            ) {
                setShowDropdown(false);
            }
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [showDropdown]);

    return (
        <div>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="group-table-component">
                <div className="group-table-buttons">
                    <div className="d-flex">
                        <div className="delete-button">
                            {updatedAddress.length > 0 && (
                                <ButtonElement
                                    className="delete-button-icon"
                                    type="button"
                                    icon="pi pi-trash"
                                    onClick={() => confirmDeleteContact()}
                                />
                            )}
                        </div>
                    </div>
                    <div className="group-table-search">
                        <HeaderSearchBar
                            value={searchQuery}
                            onChange={(e) => handleSearchChange(e)}
                            onClick={handleClearFilter}
                        />
                        <ButtonElement
                            className="clear-filter-button"
                            icon="pi pi-filter-slash"
                            onClick={resetFilter}
                        />
                        <div className="p-relative" ref={dropdownRef}>
                            <ButtonElement
                                className="clear-filter-button"
                                icon="pi pi-filter"
                                onClick={toggleDropdown}
                            />
                            {showDropdown && (
                                <>
                                    <div className="s-field">
                                        <div className="new-field w-100">
                                            {
                                                // havingBranch && branchIdFromLS.branch_key == 'main' &&
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            Associated To:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={filterAssociated}
                                                            optionLabel="label"
                                                            options={associated}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) =>
                                                                handleAssociatedSelection(e.value)
                                                            }
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {filterAssociatedLabel.includes("Client") && (
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            Clients:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={filterClient}
                                                            optionLabel="label"
                                                            options={clients}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) =>
                                                                handleClientSelection(e.value)
                                                            }
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            {filterAssociatedLabel.includes("Organisation") && (
                                                <div className="form-group row align-items-center mb-0 mt-0">
                                                    <div className="col-md-5 pl-0">
                                                        <label className="form-label text-left">
                                                            Organisations:
                                                        </label>
                                                    </div>
                                                    <div className="col pr-0">
                                                        <MultiSelectElement
                                                            value={filterOrg}
                                                            optionLabel="label"
                                                            options={organisations}
                                                            placeholder="-- Please select --"
                                                            maxSelectedLabels={1}
                                                            onChangeValue={(e) => handleOrgSelection(e.value)}
                                                            className="w-full"
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                        <ButtonElement
                            className="clear-filter-button"
                            type="button"
                            icon="pi pi-plus"
                            label="New"
                            onClick={() => show("right")}
                        />
                    </div>
                </div>
            </div>
            <DataTable
                value={addressData}
                columns={columns}
                searchQuery={searchQuery}
                removeField={removeField}
                rowClick={rowClick}
                dataKey="_id"
                isPrompts={true}
                onPage={onPage}
                lazyParams={lazyParams}
                totalRecords={totalRecords}
                deleted={deleted}
                onSort={onSort}
            />
            <CreateNewAddress
                visible={visible}
                position={position}
                customerId={props?.customerId}
                fieldDetail={fieldDetails}
                onHide={handleHide}
                clientId={props?.clientId}
                commonFields={commonFields}
                addressSections={addressSections}
                branch={branchIdFromLS}
            />
            <EditAddress
                visible={visibleEdit}
                position={'right'}
                customerId={props?.customerId}
                addressDetail={addressDetails}
                fieldDetail={fieldDetails}
                onHide={handleHide}
                fieldDetails={fieldDetails}
                commonFields={commonFields}
                addressSections={addressSections}
                branch={branchIdFromLS}
            />
            <Dialog
                visible={deleteContactDialog}
                breakpoints={{ "960px": "75vw", "641px": "90vw" }}
                header="Delete Address"
                modal
                footer={deleteContactDialogFooter()}
                onHide={hideDeleteContactDialog}
                className="table-dialog width-32"
                draggable={false}
            >
                <div className="confirmation-content">
                    <span className="table-description">
                        Are you sure to delete the address?
                    </span>
                </div>
            </Dialog>
        </div>
    );
}

export default Address;